import { render, staticRenderFns } from "./allListStage1CorrectValues.vue?vue&type=template&id=285c22a7"
import script from "./allListStage1CorrectValues.vue?vue&type=script&lang=js"
export * from "./allListStage1CorrectValues.vue?vue&type=script&lang=js"
import style0 from "./allListStage1CorrectValues.vue?vue&type=style&index=0&id=285c22a7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports